import type { TGenericSwitchStore, TGenericSwitchStoreValue, TSwitchStore } from "../@commonTypes/switchStore";
import { create } from 'zustand';

/**
 * Header Redux like Store
 * const { oldState, currentState } = useHeaderStore();
 * dispatchHeaderState(newState);
 */

export default function createUseSwitchStore<T extends TGenericSwitchStore>(
    defaultState?: T
): TSwitchStore<T> {
    return {
        store: create<T>(() => ({ ...defaultState } as T)),
        dispatch: function (data: Partial<T>) {
            const state = this.store.getState();
            this.store.setState({ ...state, ...data });
        },
        dispatchSwitch: function(key: keyof T, value: TGenericSwitchStoreValue){
            const state = this.store.getState();
            this.store.setState({ ...state, [key]: value });
        },
    };
}
